import { routeName } from '@/constants/routeName';
import basicOptions from '@/router/basic-options';
import List from '@/views/DistributorNotice/List/index.vue';
import Edit from '@/views/DistributorNotice/Edit/index.vue';
import Detail from '@/views/DistributorNotice/Detail/index.vue';
export default [
    {
        path: 'distributor-notice',
        name: routeName.DISTRIBUTOR_NOTICE,
        component: List,
        meta: {
            ...basicOptions,
            middleware: [
                ...basicOptions.middleware,
            ],
        },
    },
    {
        path: 'distributor-notice/create',
        name: routeName.DISTRIBUTOR_NOTICE_CREATE,
        component: Edit,
        meta: {
            ...basicOptions,
            middleware: [
                ...basicOptions.middleware,
            ],
        },
    },
    {
        path: 'distributor-notice/:distributorNoticeId/edit',
        name: routeName.DISTRIBUTOR_NOTICE_EDIT,
        component: Edit,
        meta: {
            ...basicOptions,
            middleware: [
                ...basicOptions.middleware,
            ],
        },
    },
    {
        path: 'distributor-notice/:distributorNoticeId/detail',
        name: routeName.DISTRIBUTOR_NOTICE_DETAIL,
        component: Detail,
        meta: {
            ...basicOptions,
            middleware: [
                ...basicOptions.middleware,
            ],
        },
    },
];
